// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"811":"45a04c89","1969":"cdbed0ed","4198":"cdbed0ed"}[chunkId] + ".chunk.css";
};